module.exports = __webpack_public_path__ + "img/hotel-services.1ea2c562.jpeg";